export const USER_ROLES = ["user", "admin"] as const;
export const ADMIN_USER_ROLES_FILTER = ["all", ...USER_ROLES] as const;
